export const projectNamespace = "fanfanlo/"
